export const ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
export const ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};
export const DIRECTION_OPTIONS = {
  column: 'column',
  row: 'row',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse'
};
export const JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};
export const WRAP_OPTIONS = {
  nowrap: undefined,
  wrap: 'wrap'
};